import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { authGuard } from "./core/auth/auth.guard";
import { LoginComponent } from "./core/auth/login.component";

const routes: Routes = [
  { path: "", redirectTo: "dashboard", pathMatch: "full" },
  { path: "login", component: LoginComponent },
  {
    path: "dashboard",
    loadChildren: () =>
      import("./features/dashboard/dashboard.module").then(
        (m) => m.DashboardModule,
      ),
    canActivate: [authGuard],
  },
  {
    path: "invocations/:id",
    loadChildren: () =>
      import("./features/invocation-detail/invocation-detail.module").then(
        (m) => m.InvocationDetailModule,
      ),
    canActivate: [authGuard],
  },
  { path: "**", redirectTo: "dashboard" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
